import { isCarinaApp } from "~/lib/applicationId";
import { postMessageToNative } from "~/lib/webview";
import type { FirebaseEventParams } from "./types";

/**
 * Firebase Analytics へイベントを送信する低レベル bridge（Carina=95 限定）。
 * ネイティブ側 FirebaseMessageHandler が Analytics.logEvent へ転送する。
 *
 * 直接呼ばず、source が自動付与される trackFirebaseEvent / trackFirebaseScreenView を使うこと。
 */
export const sendFirebaseEvent = (
  eventName: string,
  params: FirebaseEventParams,
): void => {
  setTimeout(() => {
    try {
      if (!isCarinaApp()) return;

      postMessageToNative({
        type: "FIREBASE_TRACK_EVENT",
        payload: { eventName, params },
      });
    } catch {
      // 補助機能のため例外は握りつぶす
    }
  }, 0);
};
